import { Breadcrumbs, Card, Container, Flex } from '@teko/ds-desktop';
import { NoProductsFound } from '@teko/teko-ecommerce';
import { LazyComponent } from 'components/LazyComponent';
import { NotFoundProductLayout } from 'components/ProductDetail/styles';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { ProductInfo } from 'modules/product-detail/shared/NewLayoutComponents';
import { ReviewSection } from 'modules/product-detail/shared/ProductReview/ReviewSection';
import { Box } from 'reflexbox';
import { ProductDescription } from './NewProductDescription';

export const NewDetailPage = () => {
  const { product, breadcrumbs } = useProductDetailState();
  const { epicOmni1550 } = useTenantConfig();

  if (!product) {
    return (
      <NotFoundProductLayout>
        <NoProductsFound show text={t('Không tìm thấy sản phẩm')} />
      </NotFoundProductLayout>
    );
  }

  return (
    <Container marginBottom="s16">
      <Breadcrumbs breadcrumbs={breadcrumbs || []} />
      <Card padding="s12">
        <Flex>
          <Box width="57.5%" paddingRight={24}>
            {/* Product images/video section */}
          </Box>
          <Box width="calc(100% - 57.5% - 24px)">
            {/** Flashsale promotion at top */}
            <Card marginBottom="s12">
              <ProductInfo />
            </Card>
          </Box>
        </Flex>
      </Card>
      <LazyComponent>
        <Flex gap="s16" marginTop="s16" align="start">
          <Box width="68.5%">
            <Card>
              <ProductDescription
                tabTitle={[t('Thông số kỹ thuật'), t('Chi tiết sản phẩm')]}
                buttonType="ghost"
              />
            </Card>
          </Box>
          <Box width="calc(100% - 68.5% - 16px)">
            <Card>Related news</Card>
            <Card marginTop="s16">Related videos</Card>
          </Box>
        </Flex>
      </LazyComponent>
      <LazyComponent>{epicOmni1550 && <ReviewSection />}</LazyComponent>
      <LazyComponent>
        <Card marginTop="s16">Q&A</Card>
      </LazyComponent>
      <LazyComponent>
        <Card marginTop="s16">Related products</Card>
      </LazyComponent>
    </Container>
  );
};
